import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import Image from 'presentations/views/components/atoms/Image';
import { white } from 'presentations/views/styles/color';
import { borderRadius, mediaMax, spacing } from 'presentations/views/styles';
import styled from '@emotion/styled';

export default function Component() {
  const t = translateInComponent(translations);
  return (
    <ServiceCompanyList>
      <Item>
        <LogoImage
          width={100}
          height={36}
          src="pages/top/logos/rgf.png"
          alt={t('rgf')}
          dpr={2}
        />
      </Item>
      <Item>
        <LogoImage
          width={392}
          height={36}
          src="pages/top/logos/toyota.png"
          alt={t('toyota')}
          dpr={2}
        />
      </Item>
      <Item>
        <LogoImage
          width={82}
          height={28}
          src="pages/top/logos/logo_agc.svg"
          alt={t('agc')}
          dpr={2}
        />
      </Item>
      <Item>
        <LogoImage
          width={100}
          height={36}
          src="pages/top/logos/logo_smaregi.svg"
          alt={t('smaregi')}
          dpr={2}
        />
      </Item>
      <Item>
        <LogoImage
          width={136}
          height={36}
          src="pages/top/logos/logo_kiyo.png"
          alt={t('kiyo')}
          dpr={2}
        />
      </Item>
      <Item>
        <LogoImage
          width={241}
          height={60}
          src="pages/top/logos/logo_17live.svg"
          alt={t('17live')}
          dpr={2}
        />
      </Item>
      <Item>
        <LogoImage
          width={172}
          height={28}
          src="pages/top/logos/logo_spacemarket.svg"
          alt={t('spacemarket')}
          dpr={2}
        />
      </Item>
      <Item>
        <LogoImage
          width={166}
          height={28}
          src="pages/top/logos/logo_asahi.svg"
          alt={t('asahi')}
          dpr={2}
        />
      </Item>
      <Item>
        <LogoImage
          width={264}
          height={56}
          src="pages/top/logos/logo_nyle.png"
          alt={t('nyle')}
          dpr={2}
        />
      </Item>
      <Item>
        <LogoImage
          width={123}
          height={28}
          src="pages/top/logos/logo_helpfeel.svg"
          alt={t('helpfeel')}
          dpr={2}
        />
      </Item>
      <Item>
        <LogoImage
          width={114}
          height={28}
          src="pages/top/logos/logo_ecrowd.svg"
          alt={t('ecrowd')}
          dpr={2}
        />
      </Item>
      <Item>
        <LogoImage
          width={152}
          height={28}
          src="pages/top/logos/logo_jx.png"
          alt={t('jx')}
          dpr={2}
        />
      </Item>
    </ServiceCompanyList>
  );
}

const ServiceCompanyList = styled.div`
  /* background-color: ${white}; */
  /* box-shadow: 0px 10px 30px rgba(101, 101, 101, 0.08); */
  border-radius: ${borderRadius(40)};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
  min-height: 170px;
  padding: ${spacing(24)};
  ${mediaMax.tablet} {
    box-shadow: none;
    padding: ${spacing(24)} ${spacing(12)};
    border-radius: 0;
  }
`;
const LogoImage = styled(Image)`
  margin: ${spacing(8)} 0;
  max-height: 28px;
  width: auto;
  ${mediaMax.tablet} {
    margin-bottom: ${spacing(16)};
  }
`;

const Item = styled.div`
  margin-right: ${spacing(32)};
  ${mediaMax.tablet} {
    margin-right: ${spacing(24)};
  }
  :last-of-type {
    margin-right: 0;
  }
`;
